import gql from 'graphql-tag';

const ftbLocationsQuery = gql`
  query ftbLocationsQuery {
    ftbLocations {
      name
    }
  }
`;

export default ftbLocationsQuery;
